import React, { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";

import { useDrizzleContext } from "../drizzle/drizzleContext";

import Button from '../components/Button';

const ChangePassword = ({
  close,
}) => {
  const drizzle = useDrizzleContext();

  const ref = useRef(null);

  const [ data, setData ] = useState({ password: "" });
  const [ changingPassword, setChangingPassword ] = useState(true);

  const handleSubmit = e => {
    e.preventDefault();
    const password = data.password;
    const pk = drizzle.web3.eth.accounts.wallet[0].privateKey;
    const encryptedAccountJson = JSON.stringify(drizzle.web3.eth.accounts.encrypt(pk, password));

    const suffix = "20220202091200000";
    const hashedSuffix = drizzle.web3.utils.keccak256(suffix).replace(/^0x/, '');
    const accountPathname = "tkggbs-" + hashedSuffix;
    const pkFilename = localStorage.getItem(accountPathname) 

    localStorage.setItem(pkFilename, encryptedAccountJson);

    setChangingPassword(false);
    e.target.reset();
  };

  const handleChange = e => {
    setData({...data, [e.target.name]: e.target.value});
  };

  const [ finetuneX, setFinetuneX ] = useState(null);

  useEffect(() => {
    if (ref === null)
      return;

    setFinetuneX(ref.current.getBoundingClientRect().width);
  }, [ref]);

  return (
    <div className="modal-signup">
      { changingPassword
        ? <>
          <div ref={ref} className='mt4 mh4 f4 white'>Please change the password for your private key.</div>
            <form className='flex flex-column' onSubmit={handleSubmit}>
              <input
                type="password"
                name="password"
                placeholder="Password"
                onChange={handleChange}
                className='mt4 mh4 focus-outline'
                style={{ borderColor: '#ffffff' }}
              />
              <Button className='mv4 mh4'>Next</Button>
            </form>
          </>
        : <>
          <div ref={ref} className='mt4 mh4 f4 white'>Successfully changed your password!</div>
          <Button className='mv4 mb4 mh4 w-90' style={{ width: finetuneX }} onClick={close}>Close</Button>
         </> }
    </div>
  )
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps)(ChangePassword);

